import { Controller } from "@hotwired/stimulus"

const SYSTEM_FONTS = ["Arial", "Georgia", "Courier New", "Times New Roman"]

// Updates font preview when font selection changes, loading Google Fonts dynamically
export default class extends Controller {
  static targets = ["select", "sampleText", "sampleSmall", "preview"]

  connect() {
    this.loadedFonts = new Set()
    this.update()
  }

  update() {
    const fontFamily = this.selectTarget.value
    const cssValue = `'${fontFamily}', sans-serif`

    // Apply style immediately so the browser uses the font as soon as it's loaded
    if (this.hasSampleTextTarget) {
      this.sampleTextTarget.style.fontFamily = cssValue
    }

    if (this.hasSampleSmallTarget) {
      this.sampleSmallTarget.style.fontFamily = cssValue
    }

    // Load the Google Font in the background
    this.loadFont(fontFamily)
  }

  async loadFont(fontFamily) {
    if (SYSTEM_FONTS.includes(fontFamily) || this.loadedFonts.has(fontFamily)) {
      return
    }

    this.loadedFonts.add(fontFamily)
    const encoded = fontFamily.replace(/ /g, "+")
    const url = `https://fonts.googleapis.com/css2?family=${encoded}:wght@400;500;600;700&display=swap`

    // Skip if already in the DOM
    if (document.querySelector(`link[href="${url}"]`)) return

    const link = document.createElement("link")
    link.href = url
    link.rel = "stylesheet"
    document.head.appendChild(link)
  }
}
